import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-48adad0e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "statusCard shadowed" }
const _hoisted_2 = { class: "headerRow" }
const _hoisted_3 = { class: "nameAndDescription" }
const _hoisted_4 = { class: "name" }
const _hoisted_5 = { class: "description pt-1" }
const _hoisted_6 = { class: "start" }
const _hoisted_7 = {
  key: 0,
  class: "startTabletOnly"
}
const _hoisted_8 = { class: "ctaButton startButton" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-pen mr-1" }, null, -1))

import { sessionState } from '@/core/session';
import OnlineSocialSecurityApplicationStatus from '@/features/applications/onlineSocialSecurity/OnlineSocialSecurityApplicationStatus.vue';
import { Core } from '@minicity/core';


export default /*#__PURE__*/_defineComponent({
  __name: 'ApplicationCreationCard',
  props: {
    name: null,
    description: null,
    applicationType: null,
    isDraft: { type: Boolean },
    isTabletOnly: { type: Boolean }
  },
  emits: ['changed'],
  setup(__props: any, { emit }) {

const props = __props as {
  name: string,
  description: string,
  applicationType: Core.EntityType | "identification",
  isDraft: boolean,
  isTabletOnly: boolean,
}






return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(__props.name), 1),
        _createElementVNode("div", _hoisted_5, _toDisplayString(__props.description), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        (__props.isTabletOnly)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, " To apply, please use the Mini City tablet at " + _toDisplayString(_unref(sessionState).session?.user.assignedCareProvider?.name), 1))
          : (__props.applicationType == _unref(Core).EntityType['Online Social Security'])
            ? (_openBlock(), _createBlock(OnlineSocialSecurityApplicationStatus, {
                key: 1,
                application: null,
                onChanged: _cache[0] || (_cache[0] = ($event: any) => (emit('changed')))
              }))
            : (_openBlock(), _createBlock(_component_router_link, {
                key: 2,
                to: `applications/${__props.applicationType}`
              }, {
                default: _withCtx(() => [
                  _createElementVNode("button", _hoisted_8, [
                    _hoisted_9,
                    _createTextVNode(" " + _toDisplayString(__props.isDraft ? 'Continue Application' : 'Start Application'), 1)
                  ])
                ]),
                _: 1
              }, 8, ["to"]))
      ])
    ])
  ]))
}
}

})